import React from 'react';
import { useSelector } from 'react-redux';

export function Logo({ className = '', url = null, isVariant = false }) {
  const { siteLogo = {} } = useSelector((s) => s.appConfig.pageMeta);
  const { path, variant, alt, title } = siteLogo;
  const defaultLogo = isVariant ? variant : path;
  return <img className={className} src={url || defaultLogo} alt={alt} title={title} />;
}
